import { DISPLAY_VIDEO_360 } from '../layouts/displayVideo360.layout'
import { LANDING_PAGE } from '../layouts/landingPage.layout'
import { PERFORMANCE_MAX_CAMPAIGNS } from '../layouts/performanceMax.layout'
import { PLACEMENT_ANALYSIS } from '../layouts/placementAnalysis.layout'
import { SEARCH_ADS_EXCELLENCE } from '../layouts/searchAdsExcellence.layout'

import {
  registerReportLayout,
  type ReportLayoutConfig,
  type ReportLayoutKey,
} from '@/features/reports'

const MARKETING_INSIGHTS_REPORT_LAYOUTS = {
  DISPLAY_VIDEO_360,
  LANDING_PAGE,
  PLACEMENT_ANALYSIS,
  PERFORMANCE_MAX_CAMPAIGNS,
  // Moved out of 08's seed table by ORP-18922 (see `reports/configs/layouts.ts` handoff protocol).
  SEARCH_ADS_EXCELLENCE,
} as const satisfies Record<string, ReportLayoutConfig>

export function registerMarketingInsightsLayouts(
  register: (key: ReportLayoutKey, config: ReportLayoutConfig) => () => void = registerReportLayout,
): () => void {
  const undos = Object.entries(MARKETING_INSIGHTS_REPORT_LAYOUTS).map(([key, config]) =>
    register(key, config),
  )
  return () => {
    for (const undo of undos) undo()
  }
}
